import Plate from "../Plate/Plate";

import "./ArticlePreview.scss";

export default function ArticlePreview({ title, content }) {
  return (
    <article className="article-preview">
      <h2 className="article-preview__title">{title}</h2>
      <Plate className="article-preview__content">
          <div>{content}</div>
      </Plate>
    </article>
  );
}
